interface CommentItem {
  avatar: string;
  name: string;
  time: string;
  content: string;
  tag: string;
}

const comments: CommentItem[] = [
  {
    avatar: 'ri-user-3-line',
    name: '追番小王子',
    time: '2天前',
    content: '51动漫的下拉式阅读体验真的太棒了！以前在别的平台看漫画要点来点去翻页，这里直接往下滑就自动加载下一话，一口气追完了剑与魔法全部142话，完全停不下来。画质也很高清，加载速度超快！',
    tag: '剑与魔法',
  },
  {
    avatar: 'ri-user-3-line',
    name: '樱花飘落时',
    time: '3天前',
    content: '作为一个国漫爱好者，在51动漫找到了好多宝藏国产动画。星域传说的画面品质真的惊艳到我了，完全不输日漫大作。而且更新速度也很快，每周六准时上线，追番从未断过。强烈推荐给所有国漫粉！',
    tag: '星域传说',
  },
  {
    avatar: 'ri-user-3-line',
    name: '深夜补番人',
    time: '5天前',
    content: '免费、无广告、全集观看，这三点就足够让我成为51动漫的忠实用户了。韩漫的契约婚姻番外篇在别的平台都要付费，这里直接全免。移动端适配也做得很好，睡前躺床上刷几话日常笑料部，一天的疲劳都没了。',
    tag: '契约婚姻',
  },
  {
    avatar: 'ri-user-3-line',
    name: '次元穿梭者',
    time: '1周前',
    content: '入坑51动漫半年了，见证了平台资源从几千部到两万多的增长。更新动态模块特别好用，每天打开看一眼就知道哪些作品更新了，追番效率翻倍。暗夜追踪者第二季全集上线那天直接看到凌晨三点，太过瘾了！希望平台越做越好。',
    tag: '暗夜追踪者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            用户心声
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            听听动漫迷们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
                  <i className={`${comment.avatar} text-lg`}></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <span className="ml-auto inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  {comment.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}